<template>
  <a-card>
    <elwrapper label="Name" midtext>
      <f-text v-model="name" :disabled="true" />
    </elwrapper>
    <elwrapper label="Image" midtext>
      <img :src="image" width="100%" alt="Preview" />
    </elwrapper>
  </a-card>
</template>

<script>
import { sortedUniqueCities } from "@/modules/database";

export default {
  data() {
    return {
      cities: [],
    };
  },
  computed: {
    name: {
      get() {
        return this.get("name");
      },
      set(newValue) {
        return this.set("name", newValue);
      },
    },
    image() {
      if (!this.name) return "";
      return `${this.$store.getters["host"]}storage/images/` + this.name;
    },
  },
  methods: {
    get(val) {
      return this.$store.getters["ImageStore/active"][val];
    },
    set(key, val) {
      return this.$store.dispatch("ImageStore/setUpdate", { key, val });
    },
    _querySuppliers() {
      return this.$store.dispatch("DatabaseStore/querySuppliers", { type: "ALL" }).then((data) => {
        this.cities = sortedUniqueCities(data);
      });
    },
  },
  mounted() {
    this._querySuppliers();
  },
};
</script>
